import useTranslation from "@hooks/use_translation";
import { Body } from "@sprout/typography";
import Toggle from "@/sprout/toggle";
import AutomationIcon from "@/sprout/icons/automation";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ApplicationQuickApplyBanner = ({ checked, onChange }: Props) => {
  const { t } = useTranslation("job_post", {
    keyPrefix: "application.quick_apply",
  });

  return (
    <div className="flex flex-col gap-4 w-full bg-pale-blue border border-iris-e50 rounded-lg px-4 py-4 md:flex-row md:items-center md:justify-between md:px-6">
      <div className="flex items-start gap-3">
        <div className="bg-iris-e50 shrink-0 hidden md:flex items-center justify-center rounded p-1">
          <AutomationIcon size={"md"} color="dark-green" />
        </div>
        <div className="flex flex-col gap-0.5">
          <Body medium className="text-sm! md:text-base! text-dark-green">
            {t("header")}
          </Body>
          <Body secondary className="text-xs! md:text-sm! text-dark-green">
            {t("body")}
          </Body>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0">
        <Toggle checked={checked} onChange={onChange} ariaLabel={t("header")} />
        <Body className="text-sm! md:text-base! text-dark-green whitespace-nowrap">
          {checked ? t("toggle_on") : t("toggle_off")}
        </Body>
      </div>
    </div>
  );
};

export default ApplicationQuickApplyBanner;
